module.exports = __webpack_public_path__ + "static/media/Artemis.2df49622.png";